import './SelectGroup.css'
import { DetailedHTMLProps, SelectHTMLAttributes } from 'react'
import cx from 'classnames'
import { InputSize, inputClasses } from '../Input/Input'
import { Label } from '../InputLabel/InputLabel'

type SelectGroupOptions = {
  label: string
  value: string
  disabled?: boolean
}[]

type SelectProps = DetailedHTMLProps<SelectHTMLAttributes<HTMLSelectElement>, HTMLSelectElement> & {
  label?: string
  sizeType?: InputSize
  options: SelectGroupOptions
  placeholder?: string
  selectSize?: number
  hint?: React.ReactNode
  name?: string
  hidePlaceholder?: boolean
  tooltip?: React.ReactNode
  tooltipPlacement?: 'top' | 'bottom'
  tooltipSize?: 'small' | 'medium' | 'large'
}

export function SelectGroup({
  id,
  label,
  hint,
  value,
  sizeType = 'md',
  onChange,
  options,
  hidePlaceholder,
  placeholder,
  selectSize,
  disabled,
  name,
  tooltip,
  tooltipPlacement = 'top',
  tooltipSize = 'small'
}: SelectProps) {
  return (
    <div className="select-group-container">
      {label && (
        <Label
          htmlFor={id}
          sizeType="sm"
          tooltip={tooltip}
          tooltipPlacement={tooltipPlacement}
          tooltipSize={tooltipSize}
        >
          {label}
        </Label>
      )}
      <select
        className={cx('select-base', inputClasses.sizeToClasses[sizeType], inputClasses.fixed)}
        id={id}
        value={value}
        onChange={onChange}
        disabled={disabled}
        size={selectSize}
        name={name}
      >
        {!hidePlaceholder && <option value="">{placeholder || '-'}</option>}
        {options.map(option => (
          <option key={option.value} value={option.value} disabled={option.disabled}>
            {option.label}
          </option>
        ))}
      </select>
      {hint && <span className="select-hint">{hint}</span>}
    </div>
  )
}
